import { MultiFieldDynamicFields } from '../multiFieldDynamicFields';
import { FormikProps } from 'formik';
import { MultiDynamicField } from '../../../../../shared/types/assistant';

export const ObjectiveAndResponseStrategy = ({
    formikObjectiveAndResponseStrategy,
}: {
    formikObjectiveAndResponseStrategy: FormikProps<{
        [key: string]: MultiDynamicField[];
    }>;
}) => {
    return (
        <MultiFieldDynamicFields
            formik={formikObjectiveAndResponseStrategy}
            name="objectiveAndResponseStrategy"
            label="Objetivo y Estrategia de Respuesta"
            description="Define el enfoque de respuesta del asistente virtual, estableciendo cómo resuelve las consultas de los usuarios de manera eficiente, incluyendo Resolución en Primer Contacto, Tasa de Exactitud y Tiempo de Respuesta."
            example={{
                title: 'Resolución en Primer Contacto',
                description:
                    'No redirigir a otros canales salvo casos críticos.',
            }}
        />
    );
};
